import {
  DEVICE_ID,
  DEVICE_TOKEN_KEY,
  SESSION_BROWSER_ID
} from '@shared/constants'

export const deviceSession = () => {
  let deviceId = localStorage.getItem(DEVICE_ID)

  const deviceToken = localStorage.getItem(DEVICE_TOKEN_KEY)

  if (!deviceId) {
    deviceId = crypto.randomUUID()
    localStorage.setItem(DEVICE_ID, deviceId)
  }

  let sessionId = sessionStorage.getItem(SESSION_BROWSER_ID)
  if (!sessionId) {
    sessionId = crypto.randomUUID()
    sessionStorage.setItem(SESSION_BROWSER_ID, sessionId)
  }

  return {
    deviceId,
    sessionId,
    deviceToken
  }
}

export const getDeviceName = () => {
  const ua = navigator.userAgent
  const platform = navigator.platform
  const vendor = navigator.vendor || 'unknown'

  return `${platform} - ${vendor} - ${ua}`
}
